import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum TtAudio {
    ANOTHER_FORM = "tobacco-tour-another-form.mp3",
    ANOTHER_OBJECT = "tobacco-tour-another-object.mp3",
    CIGARETTE = "tobacco-tour-cigarette-n1.mp3",
    CLICK_ON_YOUR_ANSWER = "tobacco-tour-click-on-your-answer.mp3",
    INTRO = "tobacco-tour-n1.mp3",
    CLICK_ANOTHER_PART_OF_CIGARETTE = "tobacco-tour-n3.mp3",
    FALSE = "tobacco-tour-review-false.mp3",
    TRUE = "tobacco-tour-review-true.mp3",
    REVIEW = "tobacco-tour-review.mp3",
    REVIEW_1 = "tobacco-tour-review-n1.mp3",
    REVIEW_2 = "tobacco-tour-review-n2.mp3",
    REVIEW_2A = "tobacco-tour-review-n2a.mp3",
    REVIEW_2B = "tobacco-tour-review-n2b.mp3",
    REVIEW_2C = "tobacco-tour-review-n2c.mp3",
    REVIEW_2D = "tobacco-tour-review-n2d.mp3",
    REVIEW_3 = "tobacco-tour-review-n3.mp3",
    REVIEW_3A = "tobacco-tour-review-n3a.mp3",
    REVIEW_3B = "tobacco-tour-review-n3b.mp3",
    REVIEW_3C = "tobacco-tour-review-n3c.mp3",
    REVIEW_3D = "tobacco-tour-review-n3d.mp3",
    REVIEW_4 = "tobacco-tour-review-n4.mp3",
    REVIEW_5 = "tobacco-tour-review-n5.mp3",
    REVIEW_5A = "tobacco-tour-review-n5a.mp3",
    REVIEW_5B = "tobacco-tour-review-n5b.mp3",
    REVIEW_5C = "tobacco-tour-review-n5c.mp3",
    REVIEW_5D = "tobacco-tour-review-n5d.mp3",
    REVIEW_6 = "tobacco-tour-review-n6.mp3",
    REVIEW_7 = "tobacco-tour-review-n7.mp3",
    REVIEW_7A = "tobacco-tour-review-n7a.mp3",
    REVIEW_7B = "tobacco-tour-review-n7b.mp3",
    REVIEW_7C = "tobacco-tour-review-n7c.mp3",
    REVIEW_7D = "tobacco-tour-review-n7d.mp3",
    REVIEW_8 = "tobacco-tour-review-n8.mp3",
    REVIEW_8A = "tobacco-tour-review-n8a.mp3",
    REVIEW_8B = "tobacco-tour-review-n8b.mp3",
    REVIEW_8C = "tobacco-tour-review-n8c.mp3",
    REVIEW_8D = "tobacco-tour-review-n8d.mp3",
    REVIEW_9 = "tobacco-tour-review-n9.mp3",
    REVIEW_9A = "tobacco-tour-review-n9a.mp3",
    REVIEW_9B = "tobacco-tour-review-n9b.mp3",
    REVIEW_9C = "tobacco-tour-review-n9c.mp3",
    REVIEW_9D = "tobacco-tour-review-n9d.mp3",
    REVIEW_10 = "tobacco-tour-review-n10.mp3",
    REVIEW_10A = "tobacco-tour-review-n10a.mp3",
    REVIEW_10B = "tobacco-tour-review-n10b.mp3",
    REVIEW_10C = "tobacco-tour-review-n10c.mp3",
    REVIEW_10D = "tobacco-tour-review-n10d.mp3",
    FINISHED_REVIEW = "tobacco-tour-review-n11.mp3",

    SMOKELESS_CHEMICALS = "tobacco-tour-smokeless-chemicals-n1.mp3",
    SMOKELESS_1 = "tobacco-tour-smokeless-n1.mp3",
    SMOKELESS_2 = "tobacco-tour-smokeless-n2.mp3",
    SNUFF_NARRATOR = "tobacco-tour-smokeless-n3.mp3",
    CHEW_NARRATOR = "tobacco-tour-smokeless-n4.mp3",
    SKULL_AUDIO = "smokeless-tour-skull-audio.mp3",

    CHEMICAL_AUDIO = "cig-tour-chemical-audio.mp3",
}

export enum TtImage {
    TABLE = "table.png",
    CIGARETTES = "cigarettes.png",
    CHEW = "chew.png",
    MICROSCOPE = "microscope.png",
    ECIG_LIQUID = "ecig-liquid-single.png",
    CHEWING_TOBACCO = "chewing-tobacco.png",
    SKULL = "skull.png",
    SNUFF_CAN = "snuff-can.png",
    MICROSCOPE_SLIDE = "microscope-slide.png",
    MICROSCOPE_VIEW = "microscope-view.png",
    TOUR_CIG = "tour-cig.png",
    TOBACCO_BACKGROUND = "tobacco-background.png",
    AMMONIA = "ammonia.png",
    ARSENIC = "arsenic.png",
    CARBON_MONOXIDE = "carbon-monoxide.png",
    FORMALDEHYDE = "formaldehyde.png",
    NICOTINE = "nicotine.png",
    NITROSAMINE = "nitrosamine.png",
    POLONIUM = "polonium.png",
    DOCTOR_NOTE = "doctor-note.png",
    LEAF_MOUTH = "leaf-mouth.png",
    POUCH = "pouch.png",
    SNUFF = "snuff.png",
    SNUFF_MOUTH = "snuff-mouth.png",
    LOOSE_LEAVES = "loose-leaves.png",
}

export enum TtAtlas {
    CIG_SMOKE = "tour-cig-smoke.json",
    TOBACCO_FLAP = "tobacco-flap.json",
    SMOKE_FLAP = "smoke-flap.json",
    FILTER_FLAP = "filter-flap.json",
    CHEMICAL_FLAP = "chemical-flap.json",
    MOVIE_BACKGROUND = "movie-background.json",
    CHEW_ANIMATION = "chew-animation.json",
    CHEWING = "chewing.json",
    HAND_DIP = "hand-dip.json",
    SALIVA = "saliva.json",
    SNUFF = "snuff.json",
    SNUFF_ANIMATION = "snuff-animation.json",
    SPITTING = "spitting.json",
    SWALLOWING = "swallowing.json",
    CHEW_BACKGROUND = "chew-background.json",
    SNUFF_BACKGROUND = "snuff-background.json",
    SMOKELESS_BACKGROUND = "smokeless-background.json",
}

export enum TtVideo {
    FILTER_VIDEO = "cig-tour-filter-video.mp4",
    SMOKE_VIDEO = "cig-tour-smoke-video.mp4",
    TOBACCO_VIDEO = "cig-tour-tobacco-video.mp4",
    AMMONIA = "tobacco-tour-ammonia.mp4",
    ARSENIC = "tobacco-tour-arsenic.mp4",
    CARBON_MONOXIDE = "tobacco-tour-carbon-monoxide.mp4",
    FORMALDEHYDE = "tobacco-tour-formaldehyde.mp4",
    NICOTINE = "tobacco-tour-nicotine.mp4",
    NITROSAMINE = "tobacco-tour-nitrosamine.mp4",
    POLONIUM = "tobacco-tour-polonium.mp4",
    SMOKELESS_ARSENIC = "tobacco-tour-smokeless-arsenic.mp4",
    SMOKELESS_FORMALDEHYDE = "tobacco-tour-smokeless-formaldehyde.mp4",
    SMOKELESS_NICOTINE = "tobacco-tour-smokeless-nicotine.mp4",
    SMOKELESS_NITROSAMINE = "tobacco-tour-smokeless-nitrosamine.mp4",
    SMOKELESS_POLONIUM = "tobacco-tour-smokeless-polonium.mp4",
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "tobacco-tour")

    load.autoLoad({
        imageEnum: TtImage,
        audioEnum: TtAudio,
        atlasEnum: TtAtlas,
        videoEnum: TtVideo,
    })
}
